import * as React from "react";
import { RefObject, useEffect, useRef, useState } from "react";
import SeverityMark from "./SeverityMark";
import AnalysedCriterion from "../commons/model/treatment/AnalysedCriterion";
import sfetch from "../commons/utils/super-fetch";
import "./CriterionCard.scss";

interface CriterionCardProps {
  criterion: AnalysedCriterion;
  onSelect?: (criterion: AnalysedCriterion, refObject: RefObject<any>) => void;
  selected?: boolean;
  printMode?: boolean;
  updatable: boolean;
}

export default function CriterionCard(props: CriterionCardProps) {
  const [updating, setUpdating] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>(null);
  const [saveSuccess, setSaveSuccess] = useState<boolean>(false);

  const ref = useRef();

  const criterion = props.criterion;

  const options = props.criterion.possibleDecisions.map((p) => (
    <option className="option" key={p.viewDecisionId} value={p.viewDecisionId}>
      {p.viewLabel}
    </option>
  ));

  const onClick = () => {
    if (props.onSelect) {
      props.onSelect(props.criterion, ref);
    }
    if (props.updatable) {
      setUpdating(true);
    }
  };

  const reset = () => {
    setUpdating(false);
    setErrorMessage(null);
  };

  const onDecisionChange = (viewDecisionId: string) => {
    if (viewDecisionId != props.criterion.decisionId) {
      let decisionId = props.criterion.possibleDecisions.find(
        (update) => update.viewDecisionId === viewDecisionId
      ).decisionId;
      let body = {
        criterionUid: props.criterion.uid,
        field: "DECISION",
        value: decisionId,
      };
      sfetch(props.criterion.updateUrl, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      })
        .then(() => {
          setSaveSuccess(true);
        })
        .catch(() => setErrorMessage(i18n["Global.InlineInput.ErrorMessage"]));
    }
  };

  useEffect(() => {
    if (saveSuccess) {
      window.location.hash = props.criterion.uid;
      document.location.reload();
    }
  }, [saveSuccess]);

  return (
    <div
      onClick={onClick}
      ref={ref}
      className={
        `criterion-card clickable severity-${criterion.severity.toLowerCase()}` +
        (props.selected ? " active" : "" + (props.updatable ? " updatable" : ""))
      }
    >
      <SeverityMark severity={criterion.severity} printMode={props.printMode} />
      <div className="h-flex align-center space-between">
        <span>{criterion.criterionLabel}</span>
        {!props.updatable || !updating ? (
          <span className="decision">{criterion.decisionLabel}</span>
        ) : (
          <>
            <select
              className="inline-input-value select"
              value={props.criterion.decisionId}
              autoFocus={updating}
              onChange={(e) => onDecisionChange(e.target.value)}
              onBlur={() => reset()}
            >
              {options}
            </select>
            <span className="error-message">{errorMessage ? <div>{errorMessage}</div> : ""}</span>
            {saveSuccess && (
              <div className={"notification-save-success-message"}>
                <i className="ic_check_circled" />
                &nbsp;
                {i18n["Page.AssessmentResult.Observation.Changed"]}
              </div>
            )}
          </>
        )}
        {props.updatable && !updating && (
          <div id="edit-treatment" className="text-action">
            <i className="ic_edit" />
            <span>{i18n["Global.Edit"]}</span>
          </div>
        )}
      </div>
    </div>
  );
  //}
}
